import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-321">
      <div className="max-w-5xl mx-auto" data-id="element-322">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-323">
          <div data-id="element-324">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-325">
              +500
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-326">
              docentes confían
            </div>
          </div>
          <div data-id="element-327">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-328">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-329">
              Tomos listos
            </div>
          </div>
          <div data-id="element-330">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-331">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-332">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-333">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-334">
              4.9/5
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-335">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-336">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-337">🇦🇷</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-338">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-339">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-340">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-341">
              MG
            </div>
            <div data-id="element-342">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-343">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-344">
                "Organicé todo el año de Italiano en una tarde. Nunca más llegué
                sin material al aula. Mis alumnos no pueden creer que aprendan
                tanto en cada clase. El solucionario me ahorra horas cada
                semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-345">
                — Mariela G., Córdoba | Docente de Italiano Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-346">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-347">
              LP
            </div>
            <div data-id="element-348">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-349">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-350">
                "Las actividades están perfectamente pensadas para el alumno
                argentino que aprende italiano. Los tomos de gramática visual
                son el hit de la clase. El Congiuntivo por fin se entiende."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-351">
                — Laura P., Rosario | Docente de Italiano Instituto de Idiomas
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-352">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-353">
              RM
            </div>
            <div data-id="element-354">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-355">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-356">
                "Nunca más llegué sin material. Mis clases de B2 sobre cultura
                italiana por fin enganchan de verdad. El tomo de C1/C2 con
                análisis literario es increíble. Vale cada peso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-357">
                — Roberto M., Buenos Aires | Docente de Italiano Secundaria +
                Instituto
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}